module.exports = __webpack_public_path__ + "img/vision.21e1777c.jpg";